import { Divider, Grid, Paper, Typography } from "@material-ui/core";
import React, { useState } from "react";

import BasesClientesSelectionForm from "components/SelectionForm/BasesClientesSelectionForm";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";
import LoaderBar from "components/LoaderBar/LoaderBar";
import PageTitle from "components/PageTitle/PageTitle";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import { dbPostDownloadFile } from "utils/DBFetchers";
import useStyles from "./styles"; 

export default function BasesClientesDashboard() {
  const classes = useStyles();
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();
  const [metrics, setMetrics] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialState, setIsInitialState] = useState(true);

  const generateRowsData = (data) => {
    setMetrics(data && data.pacientes_totales !== undefined ? data : null);
    setIsInitialState(false);
  };

  const handleExport = (urlFromForm) => {
    const downloadUrl = urlFromForm || (metrics && metrics.excel_url);
    if (downloadUrl) {
      window.open(downloadUrl, "_blank");
    } else {
      snackbarOpen(
        "error",
        "El archivo aún no está listo. Aplique los filtros primero."
      );
    }
  };

  const renderResults = () => {
    if (isLoading) {
      return (
        <Grid container justifyContent="center" xs={12} style={{ paddingTop: "2%" }}>
          <LoaderBar />
        </Grid>
      );
    }

    if (isInitialState) return null;

    return (
      <>
        <Grid
          item
          xs={12}
          style={{ marginBottom: "2%", marginTop: "2%", marginLeft: "2.5%" }}
        >
          <Typography variant="h4" className={classes.alignedText}>
            Valores
          </Typography>
          <Divider />
        </Grid>
        <Paper style={{ marginTop: 30, padding: 24 }}>
          {metrics ? (
            <Grid container spacing={4} justifyContent="center">
              <Grid item>
                <Typography variant="h6">Pacientes totales</Typography>
                <Typography variant="h3">
                  {metrics.pacientes_totales.toLocaleString("es-AR")}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6">Pacientes contactables</Typography>
                <Typography variant="h3">
                  {metrics.pacientes_contactables.toLocaleString("es-AR")}
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <Typography>No hay datos para los filtros seleccionados.</Typography>
          )}
        </Paper>
      </>
    );
  };

  return (
    <Grid>
      <PageTitle title="Pacientes Contactables" />
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <Paper elevation={3} style={{ padding: "20px" }}>
        <Grid container spacing={1}>
          <BasesClientesSelectionForm
            generateRowsData={generateRowsData}
            setIsLoading={setIsLoading}
            exportFunction={handleExport}
            isLoading={isLoading}
          />
        </Grid>
      </Paper>
      {renderResults()}
    </Grid>
  );
}